import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import type { Block, Inline } from '@contentful/rich-text-types';

export const richTextPlainTextRenderer = (content?: string | null) =>
  content
    ? documentToPlainTextString(JSON.parse(content) as Block | Inline)
    : null;

export default richTextPlainTextRenderer;
